<div class="component-container">
   <!-- Open Dialog Button -->
    <button class="open-dialog-btn" (click)="openDialog()">
        Upload Data File
    </button>

    <!-- Dialog Overlay -->
    <div class="dialog-overlay" [ngClass]="{ 'hidden': hideDialog }" id="dialogOverlay">
        <div class="dialog">
            <!-- Dialog Header -->
            <div class="dialog-header">
                <h2 class="dialog-title">Upload Data File</h2>
                <button class="close-dialog" (click)="closeDialog()">&times;</button>
            </div>

            <!-- Dialog Content -->
            <div class="dialog-content">
                <!-- Step Indicator -->
                <div class="step-indicator">
                    <div class="step" id="step1" [ngClass]="{'complete': currentStep === 2, 'active': currentStep === 1 }">
                        <span>1</span>
                        <span>Upload File</span>
                    </div>
                    <div class="step inactive" id="step2" [ngClass]="{'active': currentStep === 2, 'inactive': currentStep === 1 }">
                        <span>2</span>
                        <span>Preview Data</span>
                    </div>
                </div>

                <!-- Step 1: Upload Section -->
                <div class="upload-step" id="uploadStep" [style.display]="currentStep === 2 ? 'none': 'block'">
                    <!-- Format Example -->
                    <div class="format-example">
                        <h3 class="format-title">Required Data Format</h3>
                        <p style="color: #9ca3af; margin-bottom: 16px; font-size: 14px;">
                            Your CSV file should contain the following columns in this exact order:
                        </p>
                        <table class="example-table">
                            <thead>
                                <tr>
                                    <th>Location</th>
                                    <th>Trailer Number</th>
                                    <th>Carrier</th>
                                    <th>Status</th>
                                    <th>PO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Warehouse A</td>
                                    <td>TRL-001</td>
                                    <td>ABC Logistics</td>
                                    <td>Active</td>
                                    <td>PO-12345</td>
                                </tr>
                                <tr>
                                    <td>Warehouse B</td>
                                    <td>TRL-002</td>
                                    <td>XYZ Transport</td>
                                    <td>Pending</td>
                                    <td>PO-12346</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Upload Area -->
                    <div class="upload-area" onclick="document.getElementById('fileInput').click()" 
                         (drop)="handleDrop($event)" (dragover)="handleDragOver($event)" (dragleave)="handleDragLeave($event)">
                        <svg class="upload-icon" viewBox="0 0 24 24">
                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                        </svg>
                        <div class="upload-text">Drop your CSV, XLS and XLSX file here or click to browse</div>
                        <div class="upload-subtext">Supports CSV, XLS and XLSX files up to 10MB</div>
                    </div>

                    <input type="file" id="fileInput" class="file-input" accept=".csv, .xls, .xlsx" (change)="handleFileInput($event)">

                    <!-- File Info -->
                    <div class="file-info" id="fileInfo" [style.display]="uploadedFile ? 'block' : 'none'">
                        <div class="file-name" id="fileName">{{ uploadedFile?.name }}</div>
                        <div class="file-details" id="fileDetails">{{ uploadedFile?.type }}</div>
                    </div>
                </div>

                <!-- Step 2: Data Preview -->
                <div class="data-preview" id="dataPreview" [style.display]="currentStep === 2 ? 'block': 'none'">
                    <h3 style="margin-bottom: 16px; color: #e5e5e5;">Data Preview</h3>
                    <div style="overflow-x: auto;">
                        <table class="preview-table" id="previewTable">
                            <thead>
                                <tr>
                                    <th>Location</th>
                                    <th>Trailer Number</th>
                                    <th>Carrier</th>
                                    <th>Status</th>
                                    <th>PO</th>
                                </tr>
                            </thead>
                            <tbody id="previewTableBody">
                                <!-- Data will be populated here -->
                                 <tr *ngFor="let yard of yardsData">
                                  <td>{{ yard.location }}</td>
                                  <td>{{ yard?.trailer?.trailer }}</td>
                                  <td>{{ yard?.trailer?.carrier }}</td>
                                  <td>{{ yard.status }}</td>
                                  <td>{{ yard?.trailer?.po }}</td>
                                 </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style="margin-top: 16px; padding: 12px; background-color: #2a2a2a; border-radius: 6px; font-size: 14px; color: #9ca3af;">
                        <strong id="recordCount">{{ yardsData.length }}</strong> records loaded successfully
                    </div>
                </div>

                <!-- Dialog Actions -->
                <div class="dialog-actions">
                    <button class="button button-secondary" (click)="closeDialog()">Cancel</button>
                    <button class="button button-primary" id="previousBtn" (click)="previousStep()" [disabled]="currentStep === 1" [style.display]="currentStep === 2 ? 'block': 'none'">Pevious</button>
                    <button class="button button-primary" id="nextBtn" (click)="nextStep()" [disabled]="currentStep === 2" [style.display]="currentStep === 2 ? 'none': 'block'">Next</button>
                    <button class="button button-primary" id="importBtn" (click)="importData()" [style.display]="currentStep === 2 ? 'inline-block': 'none'">Import Data</button>
                </div>
            </div>
        </div>
    </div>

</div>